import { Box } from '@sequencehq/core-components'
import { PhaseLeftLinks, PhaseRightLinks } from './SchedulePhaseLinks'
import { ProductLeftLinks, ProductRightLinks } from './ScheduleProductLinks'
import { MinimumLeftLinks, MinimumRightLinks } from './ScheduleMinimumLinks'

/**
 * These components sit on the left and right of the timeline
 * within sticky containers. As we scroll through the timeline,
 * these will contextually show links which allow for scrolling
 * to offscreen products and phases.
 */
export const ScheduleTimelineLeftLinks = () => {
  return (
    <Box width="250px" height="100%">
      <PhaseLeftLinks />
      <MinimumLeftLinks />
      <ProductLeftLinks />
    </Box>
  )
}

export const ScheduleTimelineRightLinks = () => {
  return (
    <Box width="250px" height="100%">
      <PhaseRightLinks />
      <MinimumRightLinks />
      <ProductRightLinks />
    </Box>
  )
}
